<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Service in Active</h4>
</div>
<div class="modal-body">
    <p *ngIf="data && data.businessTransactionUnitName">
       The service with these details is actively worked in {{data.businessTransactionUnitName}}. Do want to act on this?
    </p>
</div>

<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" aria-label="Close" data-bs-dismiss="modal" (click)="cancel()">Cancel</button>
        <button class="btn--accent" type="submit" data-bs-dismiss="modal" (click)="accept()">Continue</button>
    </div>
</div>
